import axios from 'axios'
import CONFIG from '../utils/config'
import API_LIST from '../utils/apiList'

export const provider = async (payload) => {
  return axios({
    method: "post",
    url: CONFIG.API_URL_BROKER + API_LIST.API_ROUTES_BROKER.PROVIDER_LIST,
    data: payload.postData,
    headers: { "Content-Type": "multipart/form-data" },
  }).then(response => {
    if (response.data.status) {
      return {
        status: 'success',
        payload: {
          data: response.data.data,
          message: response.data.message
        }
      }
    } else {
      console.log("false",response);
      return {
        status: 'error',
        error: {
          message: response.data.message
       }
      }
    }
  }).catch((error) => {
    console.log("error");
    return {
      status: 'error',
      error
    }
  })
}

export const ProviderCategory = async (payload) => {
  console.log("courses payload",payload);
  return axios({
    method: "post",
    url: CONFIG.API_URL_BROKER + API_LIST.API_ROUTES_BROKER.PROVIDER_CATEGORY,
    data: payload.postData,
    headers: { "Content-Type": "multipart/form-data" },
  }).then(response => {
    if (response.data.status) {
      return {
        status: 'success',
        payload: {
          data: response.data.data,
          message: response.data.message
        }
      }
    } else {
      console.log("false",response);
      return {
        status: 'error',
        error: {
          message: response.data.message
       }
      }
    }
  }).catch((error) => {
    console.log("error");
    return {
      status: 'error',
      error
    }
  })
}

export const ProviderDetail = async (payload) => {
  console.log("courses payload",payload);
  return axios({
    method: "post",
    url: CONFIG.API_URL + API_LIST.API_ROUTES_BROKER.PROVIDER_DETAIL,
    data: payload.postData,
    headers: { "Content-Type": "multipart/form-data" },
  }).then(response => {
    console.log("url",CONFIG.API_URL + API_LIST.API_ROUTES_BROKER.PROVIDER_DETAIL)
    if (response.data.status) {
      return {
        status: 'success',
        payload: {
          data: response.data.data,
          message: response.data.message
        }
      }
    } else {
      console.log("false",response);
      return {
        status: 'error',
        error: {
          message: response.data.message
       }
      }
    }
  }).catch((error) => {
    console.log("error");
    return {
      status: 'error',
      error
    }
  })
}

export const ProviderVideoCategories = async (payload) => {
  console.log("videos payload",payload);
  return axios({
    method: "post",
    url: CONFIG.API_URL_BROKER + API_LIST.API_ROUTES_BROKER.VIDEO_LISTING_DATA_BY_CAT,
    data: payload.postData,
    headers: { "Content-Type": "multipart/form-data" },
  }).then(response => {
    console.log("response",response.data);
    if (response.data.status) {
      return {
        status: 'success',
        payload: {
          data: response.data,
          message: response.data.message
        }
      }
    } else {
      console.log("false",response);
      return {
        status: 'error',
        error: {
          message: response.data.message
       }
      }
    }
  }).catch((error) => {
    console.log("error");
    return {
      status: 'error',
      error
    }
  })
}

export const ProviderCoaching = async (payload) => {
  return axios({
    method: "post",
    url: payload.module==="myCoach"?CONFIG.API_URL_BROKER + API_LIST.API_ROUTES_BROKER.MY_PROVIDER_COACHING:CONFIG.API_URL_BROKER + API_LIST.API_ROUTES_BROKER.PROVIDER_COACHING,
    data: payload.postData,
    headers: { "Content-Type": "multipart/form-data" },
  }).then(response => {
    console.log("response in api",response.data);
    if (response.data.status) {
      return {
        status: 'success',
        payload: {
          data: response.data,
          message: response.data.message
        }
      }
    } else {
      console.log("response failed in api",response);
      return {
        status: 'error',
        error: {
          message: response.data.message
       }
      }
    }
  }).catch((error) => {
    console.log("response failed in api");
    return {
      status: 'error',
      error
    }
  })
}